


















































































































import Vue from 'vue';
import API from '@/api/common';
import NOC from '@/class/common/const';
//import { useRoute, useRouter } from 'vue-router';
import VariableInput, * as vi from '@/components/util/VariableInput.vue';
import {
  REFERENCE_OP_COUNT_SETTING_MAX,
  REFERENCE_OP_COUNT_SETTING_MIN,
} from '@/class/common/const/reference-operation-count-const';
import {
  ReferenceOperationCountInfo,
  OperationCountAverageInfo,
} from '@/class/models/typed/operation';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';

interface Tr {
  job: number;
  label: string;
  value: number;
  inputValue: number;
  countryAvg: number;
  companyAvg: number;
}

interface Data {
  onload: boolean;
  isDefault: boolean;
  isEditMode: boolean;
  isProcessing: boolean;
  onMouseOverOperationCountTh: boolean;
  inputSetting: vi.IVariableInput[];
  trData: Tr[];
}

interface Methods {
  fetchAvarageDatas: (api: operationcountApi) => Promise<Td[]>;
  fetchAccountSettings: () => Promise<void>;
  onClickEdit: () => void;
  onClickUpdate: () => void;
  selectBack: () => void;
  onMouseOver: () => void;
  onMouseLeave: () => void;
  updateReferenceOpCountSettings: () => Promise<void>;
}

interface Computed {
  isInputNoError: boolean;
}

interface Props {}

class Td {
  job: number;
  avg: number;
}
enum operationcountApi {
  COUNTRY = 'COUNTRY',
  COMPANY = 'COMPANY',
}

export default Vue.extend({
  name: 'OperationCount',
  components: {
    VariableInput,
  },
  data() {
    return {
      onload: false,
      isDefault: false, // SP初期表示時はdefault:true
      isEditMode: false,
      isProcessing: false,
      onMouseOverOperationCountTh: false,
      inputSetting: [
        {
          key: 'OperationCount',
          name: '',
          type: vi.INPUT_TYPE.NUMBER,
          required: true,
          error: '',
          min: REFERENCE_OP_COUNT_SETTING_MIN,
          max: REFERENCE_OP_COUNT_SETTING_MAX,
        },
      ],
      trData: {} as Tr[],
    };
  },
  computed: {
    isInputNoError() {
      return this.inputSetting.every(vi => !vi.error);
    },
  },
  async mounted() {
    this.$emit('pushPath', this.$route.path);

    const jobMap = new Map(
      NOC.JOB.JOBArray.map(({ value, text }) => [value, text]),
    );
    const countryAvgs = await this.fetchAvarageDatas(operationcountApi.COUNTRY);
    const companyAvgs = await this.fetchAvarageDatas(operationcountApi.COMPANY);
    const companyAvgMap = new Map(
      companyAvgs.map(({ job, avg }) => [job, avg]),
    );
    // 表データの設定
    // 全国と社内平均の職種数が同数取得できる前提
    this.trData = countryAvgs.map(item => ({
      job: item.job,
      label: jobMap.get(item.job) || 'noData',
      value: 0,
      inputValue: 0,
      countryAvg: item.avg,
      companyAvg: companyAvgMap.get(item.job) || 0,
    }));

    await this.fetchAccountSettings();

    this.onload = true; //読み込み完了

    let add = NOC.JOB.JOBArray.length - this.inputSetting.length;
    if (add > 0) {
      for (let i = 0; i < add; i++) {
        this.inputSetting.push({ ...this.inputSetting[0] });
      }
    }
  },
  methods: {
    // 対応する操作回数の統計情報を取得
    async fetchAvarageDatas(apiName: operationcountApi): Promise<Td[]> {
      let avgData = [] as OperationCountAverageInfo[];
      try {
        const api = new API();
        const resAvgCount = await api.get(
          'operation/count_analysis/' + apiName,
        );
        avgData = resAvgCount.data as OperationCountAverageInfo[];
        const jobMap = new Map(
          NOC.JOB.JOBArray.map(({ value, text }) => [value, text]),
        );
      } catch (e) {
        this.$emit('info', '通信できませんでした。');
      }
      return avgData.map(item => ({
        job: item.job,
        avg: Math.floor(item.op_count_avg),
      }));
    },
    // 基準操作回数の設定値を取得
    async fetchAccountSettings() {
      try {
        const api = new API();
        const resRefCount = await api.get('operation/reference_counts');
        const opCountData = resRefCount.data as ReferenceOperationCountInfo[];

        const opcMap = new Map(
          opCountData.map(({ job, reference_op_count }) => [
            job,
            reference_op_count,
          ]),
        );
        let opc = 0;
        this.trData.forEach(data => {
          opc = opcMap.get(data.job) || 0;
          data.value = opc;
        });
      } catch (e) {
        this.$emit('info', '通信できませんでした。');
      }
    },
    onClickEdit() {
      console.log('click edit');
      this.isProcessing = true;
      this.trData.forEach(tr => {
        tr.inputValue = tr.value;
      });

      this.isProcessing = false;
      this.isEditMode = true;
    },
    async onClickUpdate() {
      console.log('click update');
      this.isProcessing = true;
      if (this.isInputNoError) {
        await this.updateReferenceOpCountSettings();
        await this.fetchAccountSettings();

        this.isEditMode = false;
      }
      this.isProcessing = false;
    },
    // 戻る
    selectBack() {
      window.scrollTo(0, 0);
      this.isEditMode = false;
    },
    // 基準操作回数の設定
    async updateReferenceOpCountSettings() {
      const api = new API();
      let ref_op_count_infos: ReferenceOperationCountInfo[] = this.trData
        .filter(({ value, inputValue }) => value !== inputValue)
        .map(({ job, inputValue }) => ({
          job: job,
          reference_op_count: inputValue,
        }));

      if (ref_op_count_infos.length > 0) {
        // console.log("post");
        try {
          const res = await api.post(
            'operation/reference_counts',
            ref_op_count_infos,
          );
          // console.log("post operation/reference_counts res=", res);
        } catch (e) {
          this.$emit('info', '通信できませんでした。');
        }
      } else {
        // console.log("nothing to update");
      }
    },

    // マウスオーバーイベント
    onMouseOver() {
      this.onMouseOverOperationCountTh = true;
    },
    onMouseLeave() {
      this.onMouseOverOperationCountTh = false;
    },
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);
